import { render, staticRenderFns } from "./CourierCard.vue?vue&type=template&id=dd583174"
import script from "./CourierCard.vue?vue&type=script&lang=js"
export * from "./CourierCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports